<div  role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title">Task</h2>
      </div>
      <div class="modal-body">
        <form #taskForm="ngForm">
          <div class="row">
            <div class="col-md-12">
              
              
              <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                          <label for="taskPriority">Task Priority</label>
                          <select class="form-control" name="taskPriority" id="taskPriority" ngModel>
                              <option *ngFor="let priority of priorities" value="{{priority.id}}">{{priority.name}}</option>
                          </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                      <label for="title">Task Title</label>
                        <input class="form-control" name="title" id="title"  placeholder="Task Title" ngModel required>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="dueDate">Due Date</label>
                      <input type="date" class="form-control" name="dueDate" id="dueDate"  placeholder="Due Date" ngModel required>
                    </div>
                  </div>
                  
              </div>
              <div class="form-group">
                  <label for="details">Details</label>
                  <textarea class="form-control" name="details" id="details" rows="5" placeholder="Task Details" ngModel></textarea>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="saveTask(taskForm.value)" [disabled]="taskForm.invalid">Save Task</button>
          <button type="button" class="btn btn-light" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>